import { decodeValue, encodeValue } from "../utils/valueEncoding"
import { MapperOptions } from "../types"
import type { InputSearchFilter, InputSearchRangeFilter } from "@nosto/nosto-js/client"

function decodeUnit(unit: string, separator: string): InputSearchRangeFilter {
    const [gte, lte] = unit.split(separator)
    const range: InputSearchRangeFilter = {}
    if (lte) {
        range[lte.includes("]") ? "lt" : "lte"] = decodeValue(lte.replace(/[[{\]}']/gm, ""), separator)
    }
    if (gte) {
        range[gte.includes("[") ? "gt" : "gte"] = decodeValue(gte.replace(/[[{\]}']/gm, ""), separator)
    }
    return range
}

const filterComponent = {
    decode(filterUrl: string): string[] {
        return filterUrl.split("||").map(value => decodeValue(value, "~"))
    },
    encode(filters: string[]): string {
        return filters.map(value => encodeValue(value, "~")).join("||")
    }
}

const rangeComponent = {
    decode(rangeUrl: string, separator: string): InputSearchRangeFilter[] {
        return rangeUrl.split(",").map(unit => decodeUnit(unit, separator))
    },
    encode(rangeList: InputSearchRangeFilter[], options: MapperOptions): string {
        return rangeList
            .map(item => {
                const gtE = item.gte || (item.gt ? `[${item.gt}` : "")
                const ltE = item.lte || (item.lt ? `${item.lt}]` : "")
                return [gtE, ltE]
                    .map(value => encodeValue(value, options.filterRangeSeparator))
                    .join(options.filterRangeSeparator)
            })
            .join(",")
    }
}

export default {
    decode(field: string, value: string, options: MapperOptions): InputSearchFilter {
        if (value.includes("-+")) {
            const decodedValue = decodeURIComponent(value)
            return { field, range: rangeComponent.decode(decodedValue, "-+") }
        } else if (value.includes(options.filterRangeSeparator)) {
            return { field, range: rangeComponent.decode(value, options.filterRangeSeparator) }
        }
        return { field, value: filterComponent.decode(value) }
    },
    encode({ field, range, value }: InputSearchFilter, options: MapperOptions) {
        if (range) {
            return { [field!]: rangeComponent.encode(range, options) }
        } else if (value) {
            return { [field!]: filterComponent.encode(value) }
        }
        return {}
    }
}
